'use client';

import {styled} from "@mui/system";
import {Box} from "@mui/material";

const MetricsItemBox = styled(Box)(() => ({
    fontSize: '1rem',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    display: 'flex',
}));

export default MetricsItemBox;
